export default __webpack_public_path__ + "static/media/sitka-small-815.00c27455.ttf";